/**
 * Web: INVITE по WS иногда доходит до инициатора (вторая вкладка, гонка, прокси).
 * Экран «входящий» при этом не должен показываться — он только для callee.
 * Метка ставится синхронно до sendSignal в invite(); снимается при teardown звонка.
 */
const canon = (id: string) => id.trim().replace(/-/g, '').toLowerCase();

const chats = new Set<string>();

export function markLocalOutgoingCallInvite(chatId: string): void {
  chats.add(canon(chatId));
}

export function clearLocalOutgoingCallInvite(chatId: string): void {
  chats.delete(canon(chatId));
}

export function hasLocalOutgoingCallInvite(chatId: string): boolean {
  return chats.has(canon(chatId));
}
